import React  from 'react';
import SignaturePad from 'react-signature-pad';

class DrawingCanvas extends React.Component {

constructor(props) {
    super(props);
    // This binding is necessary to make `this` work in the callback
        this.handleClearClick = this.handleClearClick.bind(this);
        this.handleDrawClick = this.handleDrawClick.bind(this);
  }

  handleClearClick(){
    //SignaturePad.penColor = "white";
    var signature = this.refs.mySignature;
    var btClear = this.refs.btClear;
    var btDraw = this.refs.btDraw;
    
    signature.penColor = "white";
    signature.minWidth = 10;
    signature.maxWidth = 20;

    btClear.className="bt-clear-active btn btn-drawing";
    btDraw.className="bt-draw btn btn-drawing";

    console.log(btClear);
  }  

  handleDrawClick(){
      var signature = this.refs.mySignature;
      var btClear = this.refs.btClear;
      var btDraw = this.refs.btDraw;

        signature.penColor = "black";
        signature.minWidth = 0.5;
        signature.maxWidth = 2.5;

        btClear.className="bt-clear btn btn-drawing";
        btDraw.className="bt-draw-active btn btn-drawing";

        console.log(signature);
  }

    render() {
        //console.log(this.props);
        return (
            <div className="row">
            <SignaturePad ref="mySignature" />
            <div className="btn-drawing-group">
            <button ref="btDraw" className="bt-draw-active btn btn-drawing" onClick={this.handleDrawClick}>
                Draw</button>    
            <button ref="btClear" className="bt-clear btn btn-drawing" onClick={this.handleClearClick}>
                Erase</button>
                
            </div>    
            </div>
        );
    }
}

export default DrawingCanvas;


// WEBPACK FOOTER //
// ./src/components/exam/DrawingCanvas.js